import InfiniteScrollTable from '@app/components/InfiniteScrollTable'
import SearchBar from '@app/components/SearchBar'
import { ICityProfile } from '@app/models/CityProfile'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Link, RouteComponentProps } from 'react-router-dom'
import { Column } from 'react-virtualized'
import { Button } from 'reactstrap'
import { actionCreators, ICitiesListState } from '../modules/citiesList'

type ComponentProps = ICitiesListState &
  typeof actionCreators &
  RouteComponentProps<{}>

export default class CitiesListPage extends React.PureComponent<
  ComponentProps
> {
  private tableRef: React.RefObject<InfiniteScrollTable>

  constructor(props: ComponentProps) {
    super(props)

    bindFunctions(this)

    this.tableRef = React.createRef<InfiniteScrollTable>()
  }

  public render() {
    return (
      <DocumentTitle title='City Profiles'>
        <div className='container d-flex flex-column h-100 pt-3'>
          <div>
            <div className='d-flex flex-row justify-content-between'>
              <h3>Cities</h3>
              <Link to='/development/city/add' className='align-self-center'>
                <Button size='sm' color='primary'>
                  <FontAwesomeIcon icon={['fal', 'plus']} fixedWidth />
                  <span>Add City</span>
                </Button>
              </Link>
            </div>
            <SearchBar
              onChange={this._onChangeFilter}
              placeholder='Looking for a city?'
              size='sm'
              value={this.props.filterText}
            />
          </div>
          <div className='mt-4'>
            <InfiniteScrollTable
              isLoading={this.props.isLoading}
              items={this.props.items}
              loadItems={this.props.loadCities}
              noRowsRenderer={this._noRowsRenderer}
              onRowClicked={this._onRowClicked}
              totalItems={this.props.totalItems}
              ref={this.tableRef}
            >
              <Column
                cellDataGetter={({ rowData }) => {
                  const profile = rowData as ICityProfile
                  return profile.place.cityState
                }}
                dataKey='cityName'
                flexGrow={1}
                label='City and State'
                width={100}
              />
            </InfiniteScrollTable>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _noRowsRenderer() {
    return <div>No cities</div>
  }

  private _onRowClicked(item: ICityProfile, index: number) {
    this.props.history.push(`/development/city/${item.slug}`)
  }

  private _onChangeFilter(newFilter: string) {
    this.props.setFilterText(newFilter)
    this._reloadData()
  }

  private _onChangeSortOrder(event: React.ChangeEvent<HTMLInputElement>) {
    this.props.setSortOrder(event.target.value)
    this._reloadData()
  }

  private _reloadData() {
    if (this.tableRef.current) {
      this.tableRef.current.forceReloadData()
    }
  }
}
